import { LOADING_DOCUMENT_FOR_PRINT } from '../actions/types';
import { setter } from './utils';

export default setter(LOADING_DOCUMENT_FOR_PRINT, false);
